import React from 'react';
import { formatCurrency } from '../../../../../utils/format';
import { upperCase } from 'lodash';
import currency from 'currency.js';
import { STORAGE_URL } from '~/constants';
import NotFound from '~/assets/not-found.png';
import { useSelector } from 'react-redux';

const ItensTable = ({ itens = [], separaPorAmbiente, habilitaImagem }) => {

  const { selects } = useSelector(state => state.pdv);
  const itensPorAmbiente = new Map();

  itens.forEach(item => {
    let ambiente = "SEM AMBIENTE"

    if (separaPorAmbiente) {
      let itemAmbiente = item?.estProdutoAmbiente;
      const ambienteVazio = !itemAmbiente || Object.keys(itemAmbiente).length === 0;

      if (ambienteVazio && item?.estProdutoAmbienteId) {
        itemAmbiente = (selects?.ambientes ?? []).find(
          ambiente => ambiente.id === item.estProdutoAmbienteId
        );
      }

      item = {
        ...item,
        estProdutoAmbiente: itemAmbiente,
      };

      ambiente = item.estProdutoAmbiente?.descricao || "SEM AMBIENTE"
    }

    if (!itensPorAmbiente.has(ambiente)) {
      itensPorAmbiente.set(ambiente, {
        itens: [],
        totalQuantidade: Number(
          currency(0, {precision: 2})
        ),
        totalValor: Number(
          currency(0, {precision: 2})
        ),
        totalPrecoBruto: Number(
          currency(0, {precision: 2})
        ),
        totalDesconto: Number(
          currency(0, {precision: 2})
        ),
        totalAcrescimo: Number(
          currency(0, {precision: 2})
        ),
        totalPrecoLiquido: Number(
          currency(0, {precision: 2})
        ),
      });
    }

    const ambienteData = itensPorAmbiente.get(ambiente);
    ambienteData.itens.push(item);

    ambienteData.totalQuantidade = Number(
      currency(ambienteData.totalQuantidade, {precision: 2})
      .add(item.itemQuantidade)
    );

    ambienteData.totalPrecoBruto = Number(
      currency(ambienteData.totalPrecoBruto, {precision: 2})
      .add(item.itemValorUnitario)
    );

    ambienteData.totalDesconto = Number(
      currency(ambienteData.totalDesconto, {precision: 2})
      .add(item.itemValorDesconto)
    );

    ambienteData.totalAcrescimo = Number(
      currency(ambienteData.totalAcrescimo, {precision: 2})
      .add(item.itemValorAcrescimo)
    );

    ambienteData.totalPrecoLiquido = Number(
      currency(ambienteData.totalPrecoLiquido, {precision: 2})
      .add(item.itemValorTotal / item.itemQuantidade)
    );

    ambienteData.totalValor = Number(
      currency(ambienteData.totalValor, {precision: 2})
      .add(item.itemValorTotal)
    );

    itensPorAmbiente.set(ambiente, ambienteData);
  })

  let itemCounter = 0

  return (
    <>

      <style>{`
        .main-cells th:first-child,
        .main-cells td:first-child {
          padding-left: var(--spacing-size) !important;
        }

        .main-cells th:last-child,
        .main-cells td:last-child {
          padding-right: var(--spacing-size) !important;
        }
      `}</style>

      <div className='scrollable' style={{ border: '1px solid black', borderBottom: 'none', overflowX: 'auto' }}>

        <div style={{ fontSize: 'var(--section-title-text-size)', fontWeight: '700', padding: 'var(--spacing-size)', paddingBottom: separaPorAmbiente ? '0px' : 'var(--half-spacing-size)' }}>
          ITENS
        </div>

        <table
          style={{
            fontSize: 'var(--regular-text-size)',
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'auto',
          }}
        >

          {itens.length === 0 ? (

            <tr className='no-break'>
              <td colSpan={habilitaImagem ? 11 : 10} style={{ padding: 0, padding: `var(--half-spacing-size) 0px` }}>
                <div style={{ borderBottom: '1px solid black', margin: `var(--half-spacing-size) var(--spacing-size)` }} />
                <div style={{ paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)', paddingTop: 'var(--half-spacing-size)', paddingBottom: 'var(--half-spacing-size)' }}>
                  <div style={{ fontSize: 'var(--regular-text-size)', paddingBottom: 'var(--half-spacing-size)', fontWeight: '500' }}>
                    SEM ITENS
                  </div>
                </div>
              </td>
            </tr>

          ) : (

            <>
              {!separaPorAmbiente && (
                <React.Fragment>
                  <tr>
                    <td colSpan={habilitaImagem ? 11 : 10} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                      <div style={{ borderBottom: '1px solid black', margin: `var(--half-spacing-size) 0px` }} />
                    </td>
                  </tr>
                  <tr className='main-cells no-break'>
                    { habilitaImagem &&
                      <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Img.</th>
                    }
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>#</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Cód.</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '80px' }}>Descrição</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Unid</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Qtd</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Bruto</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Desc.</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Acrésc.</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Líquido</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Total</th>
                  </tr>
                  <tr>
                    <td colSpan={habilitaImagem ? 11 : 10} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                      <div style={{ borderBottom: '1px dashed black', margin: `var(--half-spacing-size) 0px` }} />
                    </td>
                  </tr>
                </React.Fragment>
              )}

              <tbody>

                {Array.from(itensPorAmbiente.entries()).sort(([ambiente1], [ambiente2]) => {
                  if (ambiente1 === "SEM AMBIENTE") return 1
                  if (ambiente2 === "SEM AMBIENTE") return -1
                  return ambiente1.localeCompare(ambiente2, 'pt-BR', { sensitivity: 'base' })
                }).map(([ambiente, data], ambienteIdx) => (

                  <React.Fragment key={ambienteIdx}>
                    {separaPorAmbiente && (
                      <tr className='no-break'>
                        <td colSpan={habilitaImagem ? 11 : 10} style={{ padding: 0, padding: `var(--half-spacing-size) 0px` }}>
                          <div style={{ borderBottom: '1px solid black', margin: `var(--half-spacing-size) var(--spacing-size)` }} />
                          <div style={{ paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)', paddingTop: 'var(--half-spacing-size)' }}>
                            <div style={{ paddingBottom: 'var(--half-spacing-size)' }}>
                              <span style={{ fontSize: 'var(--regular-text-size)', fontWeight: 500 }}>Ambiente:</span>{' '}
                              <span style={{ fontSize: 'var(--section-title-text-size)', fontWeight: 700 }}>{upperCase(ambiente)}</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {separaPorAmbiente && (
                      <React.Fragment>
                        <tr className='main-cells no-break'>
                          { habilitaImagem &&
                            <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap',  }}>Img.</th>
                          }
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>#</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Cód.</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '80px' }}>Descrição</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Unid</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Qtd</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Bruto</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Desc.</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Acrésc.</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Líquido</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Total</th>
                        </tr>
                        <tr>
                          <td colSpan={habilitaImagem ? 11 : 10} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                            <div style={{ borderBottom: '1px dashed black', margin: `var(--half-spacing-size) 0px` }} />
                          </td>
                        </tr>
                      </React.Fragment>
                    )}

                    {[...data.itens].sort((item1, item2) => {
                      return item1.produtoDescricao.localeCompare(item2.produtoDescricao, 'pt-BR', {sensitivity: 'base'})
                    }).map((item) => {

                      itemCounter++;
                      let imgUrl = item?.produtoEstProduto?.foto ? `${STORAGE_URL}produtos/${item?.produtoEstProduto?.foto}` : ''
                      return (
                        <tr className='main-cells no-break'>
                          { habilitaImagem &&
                            <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)` }}>
                              <img src={imgUrl || NotFound} alt="Img" style={{width: 'var(--item-img-size)', height: 'var(--item-img-size)'}} />
                            </td>
                          }
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{itemCounter}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{item.produtoCodigo}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', width: '100%', maxWidth: '80%' }}>{item.produtoDescricao}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{item.produtoUnidadeComercial}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{item.itemQuantidade}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorUnitario)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorDesconto)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorAcrescimo)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorTotal / item.itemQuantidade)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorTotal)}</td>
                        </tr>
                      );
                    })}

                    {separaPorAmbiente && (
                      <React.Fragment>
                        <tr>
                          <td colSpan={habilitaImagem ? 11 : 10} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                            <div style={{ borderBottom: '1px dashed black', margin: `var(--half-spacing-size) 0px` }} />
                          </td>
                        </tr>
                        <tr className='main-cells no-break' style={{ fontWeight: '700' }}>
                          { habilitaImagem &&
                            <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          }
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) 0px`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }}>SUBTOTAL:</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(data.totalValor)}</td>
                        </tr>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
              <tr>
                <td colSpan={habilitaImagem ? 11 : 10} style={{ paddingTop: 'var(--spacing-size)' }}></td>
              </tr>
            </>

          )}

        </table>
      </div>
    </>
  );


};

export default ItensTable;
